import styled, { createGlobalStyle } from 'styled-components';

export const DarkBackdrop = createGlobalStyle`
  .modal-backdrop.conlicitaseg-signup-backdrop.show {
    opacity: 0.8;
  }
`;

export const Background = styled.div`
  width: 100%;
  filter: blur(4px);
  pointer-events: none;
  user-select: none;
`;
